import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'core/store';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import './index.css';
import '@ingka/button/style.scss';
import '@ingka/svg-icon/style.scss';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import { msalConfig } from 'core/auth/authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import App from './components/App';
import ReactGA from 'react-ga4';

const container = document.getElementById('root');
const root = createRoot(container);
export const msalInstance = new PublicClientApplication(msalConfig);

ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID, {
  gaOptions: {
    anonymizeIp: true,
    cookieFlags: 'SameSite=None;Secure',
  },
  gtagOptions: {
    anonymize_ip: true,
    geo_granularity: 'none',
  },
});

root.render(
  <Provider store={store}>
    <Router basename={process.env.PUBLIC_URL} history={createBrowserHistory}>
      <MsalProvider instance={msalInstance}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </MsalProvider>
    </Router>
  </Provider>
);

if (module.hot && process.env.NODE_ENV === 'development') {
  module.hot.accept('./components/App', root);
}
